module.exports = __webpack_public_path__ + "static/media/urbantracker.cb4e0e35.jpg";